import React, { useState, useRef } from 'react';
import './SearchBar.css';

export default function SearchBar({ onSearch, loading }) {
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) onSearch(query.trim());
  };

  const handleClear = () => {
    setQuery('');
    inputRef.current?.focus();
  };

  const suggestions = ['Chicken', 'Pasta', 'Sushi', 'Curry', 'Biryani', 'Pizza', 'Tacos', 'Soup'];

  return (
    <div className="search-section">
      <form className="search-form" onSubmit={handleSubmit}>
        <div className="search-box">
          <span className="search-icon">
            {loading
              ? <span className="search-spinner" />
              : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            }
          </span>
          <input
            ref={inputRef}
            className="search-input"
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Search any recipe or ingredient…"
            autoFocus
            autoComplete="off"
            spellCheck="false"
          />
          {query && (
            <button type="button" className="search-clear" onClick={handleClear} aria-label="Clear">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          )}
          <button
            type="submit"
            className={`search-btn${loading ? ' loading' : ''}`}
            disabled={loading || !query.trim()}
          >
            {loading ? 'Searching…' : 'Search'}
          </button>
        </div>
      </form>

      <div className="search-suggestions">
        <span className="suggestions-label">Try:</span>
        {suggestions.map(s => (
          <button
            key={s}
            className="suggestion-pill"
            onClick={() => { setQuery(s); onSearch(s); }}
            type="button"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}
